import stringifyUrl from '../stringifyUrl';

import type { PlatformType } from '@haaretz/s-types';
import type { LinkProps as NextLinkProps } from 'next/link';
export type Url = NextLinkProps['href'];

const extraNextLinks = ['?liveBlogItemId='] as const;
const appSpecialLinks = ['_app=true'] as const;

export default function isNextLink(href: Url, platform: PlatformType): boolean {
  const stringHref = stringifyUrl(href);
  // 1. External URL are always non-Next.Js
  if (!stringHref || stringHref.startsWith('http')) return false;

  if (extraNextLinks.some(extraLink => stringHref.includes(extraLink.toLowerCase()))) return true;
  if (
    platform === 'app' &&
    appSpecialLinks.some(extraLink => stringHref.includes(extraLink.toLowerCase()))
  ) {
    return false;
  }

  return stringHref.startsWith('/');
}
